import Reliability from "./Reliability";

export default Reliability;